import { ComponentProps, FC } from "react";
// eslint-disable-next-line drops/no-direct-spor-import
import { DatePicker } from "@vygruppen/spor-react";

type DatePickerProps = ComponentProps<typeof DatePicker>;
type DropsDatePickerProps = DatePickerProps & {
  withPortal: boolean;
};

export const InternalDropsDatePicker: FC<DropsDatePickerProps> = ({
  ...props
}) => <DatePicker {...props} />;
